"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const Search_1 = __importDefault(require("@material-ui/icons/Search"));
const styles_1 = require("@material-ui/core/styles");
const theme_1 = require("../../../styles/theme");
const HEADER_HEIGHT = 60 + 52 + 54;
const DIALOG_TOP_MARGIN = 32;
/**
  DialogWrapper - wraps lazy loaded lists and has search functionality
  Different from DialogueWrapper which is used for Media Fields and Location Modals
*/
const DialogWrapper = (props) => {
    const { open, onDone, onCancel, filterPlaceHolder, title, searchText, handleSearchText, loading } = props;
    const classes = useStyles();
    const [localSearchText, setLocalSearchText] = react_1.useState(searchText);
    return (react_1.default.createElement(core_1.Dialog, { open: open, className: classes.dialog, onClose: onCancel, classes: { paperScrollPaper: classes.paperRoot } },
        react_1.default.createElement("div", { className: classes.dialogTitleBar },
            react_1.default.createElement(core_1.Button, { className: classes.button, onClick: onCancel }, "Cancel"),
            react_1.default.createElement(core_1.DialogTitle, { className: classes.dialogTitle }, title),
            onDone && (react_1.default.createElement(core_1.Button, { className: classes.button, onClick: onDone }, "Done")),
            !onDone && react_1.default.createElement("div", { className: classes.radioButtonSpacer })),
        react_1.default.createElement(core_1.DialogActions, { className: classes.dialogActions }, props.actions),
        react_1.default.createElement("div", { className: classes.searchBar },
            react_1.default.createElement(core_1.Input, { startAdornment: react_1.default.createElement(core_1.InputAdornment, { position: "start" },
                    react_1.default.createElement(Search_1.default, { className: classes.searchIcon })), placeholder: filterPlaceHolder, className: classes.input, value: localSearchText, onChange: e => {
                    if (!loading) {
                        setLocalSearchText(e.target.value);
                        handleSearchText(e.target.value);
                    }
                }, disableUnderline: true })),
        react_1.default.createElement("div", { className: classes.content }, props.children)));
};
const useStyles = styles_1.makeStyles(theme => ({
    content: {
        height: `calc(100vh - ${HEADER_HEIGHT}px - ${DIALOG_TOP_MARGIN}px)`,
    },
    dialog: {
        "& [role='dialog']": {
            width: 650,
            marginBottom: 0,
            maxHeight: `calc(100vh - ${DIALOG_TOP_MARGIN}px)`,
        },
    },
    dialogTitleBar: {
        backgroundColor: theme.palette.secondary.main,
        color: theme_1.colors.white,
        boxSizing: 'border-box',
        padding: '0 8px',
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between',
    },
    dialogTitle: {
        fontSize: 18,
        maxWidth: '25rem',
    },
    button: {
        color: theme_1.colors.white,
    },
    radioButtonSpacer: {
        width: '68px', //width of done button
    },
    dialogActions: {
        justifyContent: 'flex-start',
        backgroundColor: theme.palette.grey[50],
        height: 50,
        boxSizing: 'border-box',
    },
    searchBar: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor: theme_1.colors.white,
        color: theme.palette.grey[200],
        padding: '3px 0px',
        width: '100%',
        height: 46,
        boxSizing: 'border-box',
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: theme.palette.grey[200],
        fontSize: 16,
        '& :before': {
            display: 'none',
            borderBottom: 0,
        },
    },
    searchIcon: {
        height: 24,
        width: 24,
        paddingLeft: 14,
        color: theme.palette.grey[400],
    },
    input: {
        width: '100%',
    },
    paperRoot: {
        overflow: 'hidden',
    },
}));
exports.default = DialogWrapper;
//# sourceMappingURL=DialogWrapper.js.map